import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="announcement-settings"
export default class extends Controller {
  static targets = [
    "sensitivitySection",
    "sensitivityBtn",
    "settingBtn",
    "settingSection",
    "scheduleBtn",
    "scheduleSection",
  ]

  toggleSensitivity(event) {
    event.preventDefault()
    this.sensitivitySectionTarget.classList.toggle("hidden")
    this.sensitivityBtnTarget.classList.toggle("bg-white")
    this.sensitivityBtnTarget.classList.toggle("bg-emerald-200")
  }

  toggleSetting(event) {
    event.preventDefault()
    this.settingSectionTarget.classList.toggle("hidden")
    this.settingBtnTarget.classList.toggle("bg-white")
    this.settingBtnTarget.classList.toggle("bg-emerald-200")
  }

  toggleSchedule(event) {
    event.preventDefault()
    const isHidden = this.scheduleSectionTarget.classList.toggle("hidden")
    this.scheduleBtnTarget.classList.toggle("bg-white")
    this.scheduleBtnTarget.classList.toggle("bg-emerald-200")

    // Disable validation on hidden fields to prevent "not focusable" error
    const inputs = this.scheduleSectionTarget.querySelectorAll("input, select")
    inputs.forEach(input => {
      if (isHidden) {
        input.removeAttribute("required")
        input.removeAttribute("min")
        input.removeAttribute("max")
      }
    })
  }
}
